/**
 * Service: rulesEngine
 */
angular.module('acme.common.service.rulesEngine', [
  'acme.common.service.helpers'
])
.service('RulesEngineService', [ 'HelpersService', function(HelpersService) {

    return {

      model: [],

      groups:  {

        IN_TERM: {
          rangeOptions: {
            backgroundColor: '#e4e4e4',
            restrictColor: '#b9ced5',
            activeColor: '#169bd5',
            startRange: 0,
            endRange: 12,
            defaultStartRange: 0,
            defaultEndRange: 12,
            startLabel: 'Membership Start (0 Months)',
            endLabel: 'Membership End (12 Months)',
            startLabelTemplate: 'Membership Start (%s)',
            endLabelTemplate: 'Membership End (%s)',
            anchoredStartLabel: ' ',
            anchoredEndLabel: 'Expiration',
            disableDrag: false
          }
        },

        AFTER_TERM: {
          rangeOptions: {
            backgroundColor: '#e4e4e4',
            restrictColor: '#d1c3d1',
            activeColor: '#969',
            startRange: 0,
            endRange: 24,
            defaultStartRange: 0,
            defaultEndRange: 24,
            startLabel: 'Membership End (12 Months)',
            endLabel: '24 Months',
            startLabelTemplate: '%s',
            endLabelTemplate: '%s',
            anchoredStartLabel: ' ',
            anchoredEndLabel: 'Expiration',
            disableDrag: false
          }
        }

      },

      ruleStartExpirationBasedOptions: [
        {
          label: 'From START of membership',
          value: false
        },
        {
          label: 'From END of membership',
          value: true
        }
      ],

      init: function(rules) {
        this.model = rules;
      },

      nameToAction: function(name) {
        return name.toUpperCase().replace(/\s/g, '_');
      },

      actionToName: function(label) {

        var i, ii,
            r = [],
            parts = label.toLowerCase().split('_');

        for (i = 0, ii = parts.length; i < ii; i++) {
          r.push(HelpersService.cap(parts[i]));
        }

        return r.join(' ');
      },

      findRuleTemplate: function(id) {

        var i, ii,
            r = false;

        for (i=0,ii=this.model.length;i<ii;i++) {
          if (this.model[i].id === id) {
            r = {
              model: this.model[i],
              index: i
            };
            break;
          }
        }

        return r;

      },

      findCategory: function(templateId, categoryId) {

        var i, ii,
            r = false,
            found = this.findRuleTemplate(templateId);

        if (found) {
          for (i = 0, ii = found.categories.length; i < ii; i++) {
            if (found.categories[i].id === categoryId) {
              r = {
                category: found.categories[i],
                index: i
              };
              break;
            }
          }
        }

        return r;

      },

      findRuleById: function(templateId, categoryId, ruleId) {

        var i, ii,
            r = false,
            found = this.findCategory(templateId, categoryId);

        if (found) {
          for (i = 0, ii = found.rules.length; i < ii; i++) {
            if (found.rules[i].ruleId === ruleId) {
              r = {
                rule: found.rules[i],
                index: i
              };
              break;
            }
          }
        }

        return r;

      },

      findRuleBySection: function(templateId, categoryId, section) {

        var i, ii,
            r = false,
            found = this.findCategory(templateId, categoryId);

        if (found) {
          for (i = 0, ii = found.rules.length; i < ii; i++) {
            if (found.rules[i].section.toLowerCase() === section.toLowerCase()) {
              r = {
                rule: found.rules[i],
                index: i
              };
              break;
            }
          }
        }

        return r;

      },

      findCategoryRuleBySection: function(rules, section, describe) {

        var i, ii,
            r = false;

        if (rules instanceof Array) {
          for (i = 0, ii = rules.length; i < ii; i++) {
            if (rules[i].section.toLowerCase() === section.toLowerCase()) {
              r = {
                rule: rules[i],
                index: i
              };
              break;
            }
          }

          if (describe) {
            r.description = this.getRuleDescription(r.rule);
          }
        }

        return r;

      },

      findSelectedRuleAction: function(rule, section) {

        var i, ii,
            r = false;

        if (section && rule.section.toLowerCase() !== section.toLowerCase()) {
          return r;
        }

        for (i = 0, ii = rule.actions.length; i < ii; i++) {
          if (rule.actions[i].id === rule.selectedId) {
            r = {
              action: rule.actions[i],
              description: rule.name + ': ' + rule.actions[i].name,
              index: i
            };
            break;
          }
        }


        return r;

      },

      getRuleStartExpirationBasedOptions: function() {
        return this.ruleStartExpirationBasedOptions.slice(0);
      },

      getOfferingActionRules: function(offering, section) {

        var i, ii,
            r = false;

        if (offering.actions instanceof Array) {
          for (i = 0, ii = offering.actions.length; i < ii; i++) {
            if (offering.actions[i].action === section) {
              r = {
                ruleIds: offering.actions[i].ruleIds,
                index: i
              };
              break;
            }
          }
        }

        return r;

      },

      getRuleDescription: function(rule) {
        var r = '',
            found = this.findSelectedRuleAction(rule);

        if (found) {
          r = rule.name + ': ' + found.action.name;
        }

        return r;
      },

      getRestrictionRules: function(blockLabel) {

        var r = false,
            restrictions = {

              NEW_MEMBERSHIPS: {
                order: 1,
                rules: {
                  overlap: true,
                  overlapGroup: true,
                  acceptParams: false,
                  group: 'IN_TERM',
                  autoSelect: 'STANDARD_NEW'
                }
              },

              RENEW: {
                order: 2,
                rules: {
                  overlap: true,
                  overlapGroup: true,
                  acceptParams: true,
                  group: 'IN_TERM'
                }
              },

              UPGRADE: {
                order: 3,
                rules: {
                  overlap: false,
                  overlapGroup: true,
                  acceptParams: true,
                  group: 'IN_TERM'
                }
              },

              DOWNGRADE: {
                order: 4,
                rules: {
                  overlap: false,
                  overlapGroup: true,
                  acceptParams: true,
                  group: 'IN_TERM'
                }
              },

              CANCELLATION: {
                order: 5,
                rules: {
                  overlap: false,
                  overlapGroup: true,
                  acceptParams: true,
                  group: 'IN_TERM'
                }
              },

              REJOIN: {
                order: 2,
                rules: {
                  overlap: true,
                  overlapGroup: false,
                  overlapCascade: true,
                  acceptParams: true,
                  group: 'AFTER_TERM'
                }
              },

              AFTER_TERM_RENEW: {
                order: 1,
                rules: {
                  overlap: true,
                  overlapGroup: false,
                  acceptParams: true,
                  overlapCascade: true,
                  group: 'AFTER_TERM'
                }
              },

              groups: this.groups

            };


        if (restrictions.hasOwnProperty(blockLabel)) {
          r = restrictions[blockLabel];
          if (restrictions.groups.hasOwnProperty(r.rules.group)) {
            r.rangeOptions = angular.copy(restrictions.groups[r.rules.group].rangeOptions);
          }
        }

        return r;

      },

      updateTermGroupsEndRange: function(group, endRange) {
        this.groups[group].endRange = endRange;
      }

    };

}]);